<template>
  <div class="courses-container">
    <h3 class="fw-600">Course Curricullam</h3>
    <div style="margin-top: 30px;background: #f7f9fa; padding: 10px 0 0 0">
      <div
        v-for="(item, index) in dataSections"
        :key="index"
        style="border-bottom: 1px solid #d8dce0;"
        class=" mb-10 pointer"
      >
        <div
          @click="HandleShowDetailSection(item)"
          class="flex justify-space-between"
          style="margin-left: 15px; margin-right:15px"
        >
          <div>
            <p
              style="color: #242F41;"
              class="fw-600 m-0 c-body2 p-title-lectures"
            >
              {{ item.title }}
            </p>
            <p style="color:#242F41; font-size:14px">
              0/{{ item.lectures.length }}|7min
            </p>
          </div>
          <span
            @click="HandleShowDetailSection(item)"
            style="color:#242F41; font-size:14px"
          >
            <i
              v-if="!item.isShow"
              style="font-weight: 800;"
              class="el-icon-arrow-down"
            ></i>
            <i v-else style="font-weight: 800;" class="el-icon-arrow-up"></i>
          </span>
        </div>
        <div v-if="item.isShow" class="w-100">
          <div
            v-for="(lectures, indexLectures) in item.lectures?.filter(
              i => i?.asset?.asset_type === type_asset.VIDEO
            ) || []"
            :key="indexLectures"
            class="flex w-100 pb-5 pt-10"
            style="border-top: 1px solid #E3E3E3;"
            :style="{
              background: active === lectures.lecture_id ? '#f5f9ff' : '#ffff '
            }"
          >
            <!-- style="{ 'background': !lectures.is_free ? '#efeeee' : '' }" -->
            <div class="flex mr-10 ml-10">
              <i
                v-if="checkOpen(lectures.is_free)"
                style="font-size: 20px;"
                class="el-icon-news"
              ></i>
              <i v-else style="font-size: 20px;" class="el-icon-lock"></i>
              <div style="position: relative;" class="ml-10 w-100">
                <div @click="handleAssetLink(lectures)">
                  <p class="c-caption m-0 p-title-lectures">
                    {{ lectures.title }}
                  </p>
                  <div class="flex justify-space-between mt-10">
                    <span
                      @click="handleAssetLink(lectures)"
                      style="color:#757F8F; font-size:14px"
                    >
                      <i
                        style="margin-right: 3px;"
                        v-if="lectures.asset.asset_type === type_asset.VIDEO"
                        class="el-icon-monitor"
                      ></i>
                      <i
                        style="margin-right: 3px;"
                        v-if="lectures.asset.asset_type === type_asset.FILE"
                        class="el-icon-document"
                      ></i>
                      {{ formatTime(lectures.asset.time_estimation) }} min</span
                    >
                  </div>
                </div>
                <!-- <div
                  v-if="lectures.supplementary_assets.length > 0"
                  style="border:2px solid black; padding:0px 5px; position:absolute; right: 0; top:25px "
                >
                  <el-dropdown trigger="click">
                    <div class="avatar-wrapper">
                      <i
                        style="font-size: 14px; color:black"
                        class="el-icon-folder-opened"
                      ></i>
                      <span style="font-size: 12px" class="mr-5 ml-5 fw-500"
                        >Resources</span
                      >
                      <i
                        style="font-weight: 600;font-size: 12px"
                        class="el-icon-arrow-down"
                      ></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(supp,
                        suppIndex) in lectures.supplementary_assets"
                        :key="suppIndex"
                        divided
                        @click.native="
                          handleAssetLink(lectures, supp, supp.filename)
                        "
                      >
                        <span style="display:block;"> {{ supp.title }}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VideoPoster from "@/assets/img/img_edu/Video.png";
import TimeIcon from "@/assets/img/svg_edu/TimeIcon.svg";
import Vecter1 from "@/assets/img/svg_edu/Vector1.svg";
import Vecter2 from "@/assets/img/svg_edu/Vector2.svg";
import Vecter3 from "@/assets/img/svg_edu/Vector3.svg";
import Vecter4 from "@/assets/img/svg_edu/Vector4.svg";
import CoursesResource from "@/views/api/courses";
import axios from "axios";
export default {
  name: "Section-Courses",
  props: {
    dataSections: {
      type: Array,
      default() {
        return [];
      }
    },
    isPurchase: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  created() {},
  data() {
    return {
      type_asset: {
        FILE: "Article",
        VIDEO: "Video"
      },
      active: null,
      listData: [
        { isShow: true },
        { isShow: false },
        { isShow: false },
        { isShow: false }
      ],
      img: {
        VideoPoster
      },
      icons: {
        TimeIcon,
        Vecter1,
        Vecter2,
        Vecter3,
        Vecter4
      }
    };
  },
  watch: {},
  methods: {
    checkOpen(val) {
      return val || this.isPurchase;
    },
    handleAssetLink(item, supp = null) {
      this.active = item.lecture_id;
      if (!this.checkOpen(item.is_free)) {
        this.$message.error("Please purchase the course to view the lessons.");
        return;
      }
      if (supp) {
        this.handleGetLinkFile(item.lecture_id, supp.id, supp.filename);
        return;
      }
      if (item.asset.asset_type === this.type_asset.VIDEO) {
        window.scrollTo({
          top: 0,
          behavior: "smooth" // Nếu bạn muốn cuộn mượt
        });
        this.$emit("on-get-title", item.title);
        this.handleGetLinkVideo(item.lecture_id);
      } else {
        this.handleGetLinkFile(item.lecture_id, null, item.asset.filename);
      }
    },
    handleGetLinkVideo(lecture_id) {
      this.$emit("on-asset-link", { isShow: false, isLoading: true });
      CoursesResource.AssetLink({ lecture_id })
        .then(res => {
          const { error_code, data, error_msg } = res;
          if (error_code === 0) {
            console.log(data);
            this.$emit("on-asset-link", {
              isShow: true,
              isLoading: false,
              url_link: data.link
            });
          } else {
            this.$emit("on-asset-link", { isShow: false, isLoading: false });
            this.$message.error(error_msg);
          }
        })
        .finally(() => {});
    },
    handleGetLinkFile(
      lecture_id,
      supplementary_asset_id = null,
      file_name = null
    ) {
      this.$message.success("File đang được tải, Vui lòng đợi.");
      CoursesResource.AssetLink({ lecture_id, supplementary_asset_id }).then(
        res => {
          const { error_code, data, error_msg } = res;
          if (error_code === 0) {
            this.downLoadFile(data.link, file_name);
            // this.$message.success('Tải xuống thành công.')
            console.log(data);
          } else {
            this.$message.error(error_msg);
          }
        }
      );
    },
    async downLoadFile(link, file_name = null) {
      await axios({
        url: link,
        method: "GET",
        responseType: "blob"
      })
        .then(response => {
          console.log("response___________", response);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(error => {
          this.$message.error("File lỗi không thể tải, Vui lòng thử lại sau");
        });
    },
    HandleShowDetailSection(item) {
      item.isShow = !item.isShow;
      for (let i = 0; i < this.dataSections.length; i++) {
        const data = this.dataSections[i];
        if (item.chapter_id !== data.chapter_id)
          this.dataSections[i].isShow = false;
      }
    },
    formatTime(seconds) {
      let minutes = Math.floor(seconds / 60); // Số phút
      let remainingSeconds = seconds % 60; // Số giây còn lại sau khi chuyển đổi thành phút

      // Đảm bảo rằng số phút và số giây đều có hai chữ số
      let formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      let formattedSeconds =
        remainingSeconds < 10 ? "0" + remainingSeconds : remainingSeconds;

      return formattedMinutes + ":" + formattedSeconds;
    }
  }
};
</script>
<style scoped>
.p-title-lectures {
  word-break: break-word;
}
.search-course {
  padding: 3px 0;
  background: #eff8ff;
}
.courses-container {
}
.main-view {
  padding-top: 100px;
}
</style>
